/**
 * Error Catcher Service
 *
 * used by APIService
 * @deprecated use ErrorTracingService instead
 */

import {Yii} from "libraries/interfaces/Yii";
import { Injectable } from '@angular/core';

@Injectable()
export class ErrorCatcherService{

    private message = {
        NETWORK: {
            OFFLINE: Yii.t('wui-shared-js', 'Problème de connexion. Merci de contacter votre administrateur réseau'),
            SLOW: Yii.t('wui-shared-js', 'Connexion lente...')
        },
        DEFAULT: Yii.t('wui-shared-js', 'Une erreur est survenue...')
    };

    public catch (_response: any): void {
        let error: any|string;

        const response =  _response;
        const responseText = (response  && response.message) ?
            response.message :
            this._catchErrorMessage(response.custom);

        if (_response.status && _response.statusText){
            error = {
                title : Yii.t('wui-shared-js', 'Erreur ') + _response.status + " : " + _response.statusText,
                message : responseText
            };
        }else{
            error = responseText;
        }
        console.error(error);
    }

    public detectSuccess(_response: any): any{
        const response =  _response;

        if(!response.data || response.data.length === 0){
            return {'success': false, 'error': {'custom' : Yii.t('wui-shared-js', 'Pas de résultat')}};
        }

        return {'success':true};

    }


    private _catchErrorMessage(_customMessage: string): string {
        if (_customMessage) {
            return _customMessage;
        }

        if (!this._checkNetworkConnection()) {
            return this.message.NETWORK.OFFLINE;
        }

        return this.message.DEFAULT;
    }

    private _checkNetworkConnection(): boolean {
        return navigator.onLine;
    }
}
